module.exports = __webpack_public_path__ + "img/图片5.63fee514.png";